const domToImageMore = require("dom-to-image-more");

export default {
  install(Vue) {
    Vue.prototype.$domToImageMore = domToImageMore;
  }
}
